import { Building2, Clock, Shield, Wrench, Users, BarChart } from "lucide-react"
import { motion } from "framer-motion"

const features = [
  {
    icon: Building2,
    title: "Property Management",
    description: "Manage multiple properties with ease through our intuitive dashboard"
  },
  {
    icon: Clock,
    title: "Instant Booking",
    description: "Book maintenance services with just a few clicks"
  },
  {
    icon: Shield,
    title: "Verified Professionals",
    description: "Access our network of trusted and vetted service providers"
  },
  {
    icon: Wrench,
    title: "Smart Maintenance",
    description: "Predictive maintenance alerts and scheduling automation"
  },
  {
    icon: Users,
    title: "Team Collaboration",
    description: "Seamless communication between managers and service providers"
  },
  {
    icon: BarChart,
    title: "Analytics & Insights",
    description: "Detailed reports and insights on maintenance performance"
  }
]

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
}

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 }
}

export function Features() {
  return (
    <section className="container space-y-8 py-24 md:py-32">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mx-auto text-center md:max-w-[58rem]"
      >
        <h2 className="font-heading text-3xl font-bold leading-[1.1] sm:text-4xl md:text-5xl">
          Everything you need to manage your properties
        </h2>
        <p className="mt-4 text-muted-foreground sm:text-lg">
          Powerful features to streamline maintenance, reduce costs, and keep your properties in perfect condition.
        </p>
      </motion.div>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="mx-auto grid justify-center gap-8 sm:grid-cols-2 md:max-w-[64rem] lg:grid-cols-3"
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={item}
            className="relative overflow-hidden rounded-lg border bg-background p-2"
          >
            <div className="flex h-[180px] flex-col justify-between rounded-md p-6">
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                <feature.icon className="h-6 w-6 text-primary" />
              </div>
              <div className="space-y-2">
                <h3 className="font-bold">{feature.title}</h3>
                <p className="text-sm text-muted-foreground">
                  {feature.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  )
}